import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./SignerData.css";
import { useForm } from "react-hook-form";
import { useLocation } from 'react-router-dom';
import { useContext, useEffect, useState } from "react";
import SignerDataService from "../../services/SignerDataService";
import { useNavigate } from "react-router-dom";
import { ArrowIcon } from "../../components/SvgComponents/ArrowIcon/ArrowIcon";
import { BatchContext } from "../../contexts/BatchContext";
import { Back } from "../../components/Back/Back";

export const SignerData = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { Form } = require("react-bootstrap");
  const { register, formState: { errors }, handleSubmit, setValue, getValues } = useForm();
  const [showEmptyOption, setShowEmptyOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const { addDocumentsToBatch } = useContext(BatchContext);

  const isBatchDocument = location.state?.isBatchDocument;
  const documents = location.state?.documents;
  const emailId = location.state?.emailId;
  const returnTo = location.state?.returnTo;
  const autoContinueToSign = location.state?.autoContinueToSign;
  const skipOnPreviewForm = location.state?.skipOnPreviewForm;
  const documentItem = isBatchDocument ? documents[0] : documents;

  const signerGUI = documentItem?.SignerDTO?.SignerGUI;
  const signerData = documentItem?.SignerDTO?.SignerData;
  const signerName = documentItem?.SignerDTO?.SignerName;
  const numberID = documentItem?.SignerDTO?.NumberID;
  const typeOfID = documentItem?.SignerDTO?.TypeOfID;
  const signerNameProperties = signerData?.SignerNameProperties;
  const typeOfIdProperties = signerData?.TypeOfIdProperties;
  const numberIdProperties = signerData?.NumberIdProperties;
  const typeOfIdsAllowed = signerData?.TypeOfIdsAllowed;
  const form = documentItem?.SignerDTO?.Form;

  const sendRequestPersonalData = (data) => {
    setLoading(true);
    const body = {
      SignerName: data.name,
      TypeOfID: data.typeLegalId,
      NumberId: data.legalId
    };

    SignerDataService.sendSignerData(signerGUI, body)
      .then(response => {
        // Mark SignerData as completed locally to avoid routing loops
        if (isBatchDocument && Array.isArray(documents)) {
          documents.forEach((doc) => updateSignerDTO(doc, body));
        } else {
          updateSignerDTO(documents, body);
        }

        // If we came from Preview (AfterPreview flow), go back and auto-continue
        if (returnTo && autoContinueToSign) {
          navigate(returnTo, {
            state: {
              documents,
              emailId,
              autoContinueToSign: true,
              skipSignerDataCheck: true,
              skipOnPreviewForm: !!skipOnPreviewForm,
            }
          });
          setLoading(false);
          return;
        }

        let link = isBatchDocument ? "/documents" : "/document";
        if (form && (formDisplayIsNullOrEmpty(form.FormDisplay) || form.FormDisplay.toLowerCase() === "beforepreview")) link = "/questions";
        if (form && form.FormDisplay.toLowerCase() === "onpreview") link = "/document-questions";

        if (isBatchDocument) {
          addDocumentsToBatch(documents);
        }

        navigate(link, {
          state: {
            documents: documents,
            emailId: emailId,
          }
        });
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      });
  }

  const updateSignerDTO = (document, body) => {
    document.SignerDTO.SignerName = body.SignerName;
    document.SignerDTO.NumberID = body.NumberId;
    document.SignerDTO.TypeOfID = body.TypeOfID;
    document.SignerDTO.SignerData = null;
  };
  const hasTypeOfIdsAllowed = () => {
    return typeOfIdsAllowed && Array.isArray(typeOfIdsAllowed) && typeOfIdsAllowed.length > 0;
  };

  useEffect(() => {
    if (typeOfIdProperties.Required.toUpperCase() === "OPTIONAL") {
      setShowEmptyOption(true);
    }

    // Set Signer Name from the SignerDTO if it exists, otherwise leave it empty
    if (signerName) {
      setValue("name", signerName);
    }

    // Set Type of ID and Number ID from the SignerDTO if they exist, otherwise leave them empty
    if (typeOfID) {
      setValue("typeLegalId", typeOfID);
    }
    if (numberID) {
      setValue("legalId", numberID);
    }
  }, [typeOfIdProperties, numberID, signerName, typeOfID, setValue, typeOfIdsAllowed]);

  const isNotRequired = (propierty) => {
    return propierty.Required.toUpperCase() === "NO";
  }

  const signerNameisRequired = () => {
    return signerNameProperties.Required.toUpperCase() === "MANDATORY";
  }

  const typeOfIdisRequired = () => {
    return typeOfIdProperties.Required.toUpperCase() === "MANDATORY";
  }

  const numberIdisRequired = () => {
    return numberIdProperties.Required.toUpperCase() === "MANDATORY";
  }

  const formDisplayIsNullOrEmpty = (formDisplay) => {
    return (formDisplay === null || formDisplay === '');
  }

  return (
    <Container className="container-row row-box form-view">
      <Row>
        {returnTo && (
          <Col md={12} lg={12} className="document-preview-title" style={{ paddingLeft: '0px' }}>
            <Back handleBack={() => navigate(returnTo, { state: { documents, emailId, skipOnPreviewForm: !!skipOnPreviewForm } })} />
          </Col>
        )}
        <div className="welcome-container">
          <div className="welcome-text-container">
            <h3 style={{ fontWeight: 800 }}>{t('signer_data.title')}</h3>
            <strong><p>{t('signer_data.description')}</p></strong>
          </div>
        </div>
        <hr className="welcome-separator" />
      </Row>
      <Row>
        <Form onSubmit={handleSubmit(sendRequestPersonalData)} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          {!isNotRequired(signerNameProperties) &&
            <div className="textbox-container">
              <label>{t('signer_data.name')} {signerNameisRequired() && <span>*</span>}</label>
              <Form.Control
                style={{ textAlign: 'left' }}
                type="text"
                maxLength={255}
                {...register('name', {
                  required: signerNameisRequired(),
                  maxLength: {
                    value: 255,
                    message: t('signer_data.max_length', { max: 255 }),
                  },
                })}
                disabled={!signerNameProperties.Editable}
              />
              {errors.name?.type === 'required' && (
                <p className="required-field"> {t('signer_data.required_field')} </p>
              )}
              {errors.name?.type === 'maxLength' && (
                <p className="required-field"> {errors.name.message} </p>
              )}
            </div>
          }
          {!isNotRequired(typeOfIdProperties) &&
            <div className="textbox-container">
              <label>{t('signer_data.document_type')} {typeOfIdisRequired() && <span>*</span>}</label>
              {hasTypeOfIdsAllowed() ? (
                <Form.Select
                  {...register('typeLegalId', {
                    validate: (value) => {
                      if (value && value.length > 50) {
                        return t('signer_data.max_length', { max: 50 });
                      }
                      if (typeOfIdisRequired() || getValues('legalId')) {
                        return value !== "" || t('signer_data.required_field');
                      }
                      return true;
                    }
                  })}
                  defaultValue=""
                  disabled={!typeOfIdProperties.Editable}
                >
                  <option disabled={!showEmptyOption} value="">
                    {t('signer_data.select')}
                  </option>
                  {typeOfIdsAllowed.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control
                  style={{ textAlign: 'left' }}
                  type="text"
                  maxLength={50}
                  {...register('typeLegalId', {
                    validate: (value) => {
                      if (value && value.length > 50) {
                        return t('signer_data.max_length', { max: 50 });
                      }
                      if (typeOfIdisRequired() || getValues('legalId')) {
                        return value !== "" || t('signer_data.required_field');
                      }
                      return true;
                    }
                  })}
                  disabled={!typeOfIdProperties.Editable}
                />
              )}
              {errors.typeLegalId && (
                <p className="required-field">
                  {errors.typeLegalId.message || t('signer_data.required_field')}
                </p>
              )}
            </div>
          }
          {!isNotRequired(numberIdProperties) &&
            <div className="textbox-container">
              <label>{t('signer_data.number_id')} {numberIdisRequired() && <span>*</span>}</label>
              <Form.Control
                style={{ textAlign: 'left' }}
                type="text"
                {...register('legalId', {
                  validate: (value) => {
                    if (value && value.length > 115) {
                      return t('signer_data.max_length', { max: 115 });
                    }
                    if (numberIdisRequired() || getValues('typeLegalId')) {
                      return value !== "" || t('signer_data.required_field');
                    }
                    return true;
                  }
                })}
                maxLength={115}
                disabled={!numberIdProperties.Editable}
              />
              {errors.legalId && (
                <p className="required-field">
                  {errors.legalId.message || t('signer_data.required_field')}
                </p>
              )}
            </div>
          }
          <Row className="action-buttons mobile-button">
            <Col md={2} xs={1} lg={2}></Col>
            <Col md={8} xs={10} lg={8}>
              <button type="submit" className="btn btn-primary btn-active" disabled={loading}>
                <span className="cancel-text">{t('general.next')}</span>
                <ArrowIcon />
              </button>
            </Col>
            <Col md={2} xs={1} lg={2}></Col>
          </Row>
        </Form>
      </Row>
    </Container >
  );
};
